export class FileDocumentDto {

    documentId?: string;

    fileName?: string;

    fileId?: string;

    fileContentType?: string;

    fileSizeInBytes?: number;

    inputStream?: string;

    fileType?: string;

    filePreviewUrl?: string;

    fileDownloadUrl?: string;

    bytes?: string;

    isUploadedSuccess?: boolean;

    isActive?: boolean;

    byteArray?: any;

    publicUrl?: string;

    fileDescription?: string;

}